export default __webpack_public_path__ + "static/media/modernV2.75f8827c.webp";